import React from "react";
import types from "./types";

const Template = ({ variant, size, color, ...props }) => (
  <svg
    fill="none"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {variant === "outline" && (
      <path
        d="M1.92302 9.37004C1.41302 9.16504 1.41902 8.86004 1.95702 8.68104L21.043 2.31904C21.572 2.14304 21.875 2.43904 21.727 2.95704L16.273 22.043C16.123 22.572 15.798 22.596 15.556 22.113L11 13L1.92302 9.37004ZM6.81302 9.17004L12.449 11.425L15.489 17.507L19.035 5.09704L6.81202 9.17004H6.81302Z"
        fill={color}
      />
    )}

    {variant === "default" && (
      <path
        d="M1.94596 9.31504C1.42396 9.14104 1.41896 8.86004 1.95596 8.68104L21.043 2.31904C21.572 2.14304 21.875 2.43904 21.727 2.95704L16.273 22.043C16.123 22.572 15.818 22.59 15.594 22.088L12 14L18 6.00004L9.99996 12L1.94596 9.31504Z"
        fill={color}
      />
    )}
  </svg>
);

Template.propTypes = types.propTypes;
Template.defaultProps = types.defaultProps;

export default Template;
